<template>
  <div class="setting-online-base">
<!--    欢迎语设置-->
    <div class="module-item-style">
      <div class="module-item-title online-base-title">
        <div>
          欢迎语设置
        </div>
        <div class="online-base-switch-btn">
          <el-switch
              v-model="welecomBtn"
              @change="saveChange('company_is_greet',welecomBtn)"
              active-color="#68B974">
          </el-switch>
        </div>
      </div>
      <div class="online-base-tips">接入人工客服时，系统会向访客发出一条客服接入提示</div>
      <div class="online-base-content" v-show="welecomBtn">

        <wang-editor @editorBlurEvent="editorBlurEvent" ref="wangEditors" class="input-width"></wang-editor>
      </div>
    </div>

<!--    会话结束提示-->
    <div class="module-item-style">
      <div class="module-item-title online-base-title">
        <div>
          会话结束提示
        </div>
        <div class="online-base-switch-btn">
          <el-switch
              @change="saveChange('peroration_open',chatFinishedBtn)"
              v-model="chatFinishedBtn"
              active-color="#68B974">
          </el-switch>
        </div>
      </div>
      <div class="online-base-tips">会话结束后，系统会向访客发出一条结束提示</div>
      <div class="online-base-content" v-if="chatFinishedBtn">
        <div class="chat-finish">
          <div class="chat-finish">客服手动结束</div>
          <div>
            <el-input
                class="input-textarea"
                type="textarea"
                resize="none"
                rows="4"
                maxlength="250"
                show-word-limit
                @blur="saveChange('peroration_close_c',chatFinished)"
                placeholder="请输入内容..."
                v-model="chatFinished">
            </el-input>
          </div>
        </div>
        <div class="chat-finish">
          <div class="chat-finish">访客超时结束</div>
          <div>
            <el-input
                class="input-textarea"
                type="textarea"
                resize="none"
                rows="5"
                maxlength="250"
                show-word-limit
                @blur="saveChange('peroration_close_s',chatFinishedAuto)"
                placeholder="请输入内容..."
                v-model="chatFinishedAuto">
            </el-input>
            <div class="chat-finish-time-set">
              访客超过 <input min="0" class="chat-finish-num" v-model="chatFinishedTime" @change="saveChange('peroration_close_time',chatFinishedTime)" type="number"> 分钟无响应时自动关闭
            </div>
          </div>
        </div>
      </div>
    </div>

<!--    <div class="module-item-style">-->
<!--      <div class="module-item-title online-base-title">-->
<!--        <div>-->
<!--          验收提示信息-->
<!--        </div>-->
<!--      </div>-->
<!--      <div class="online-base-tips">在顾客收到验收提示消息时附带一段消息</div>-->
<!--      <div class="online-base-content">-->
<!--        <el-input-->
<!--            class="input-textarea"-->
<!--            type="textarea"-->
<!--            resize="none"-->
<!--            rows="4"-->
<!--            maxlength="255"-->
<!--            show-word-limit-->
<!--            @blur="saveTips('acceptance_msg',acceptance_msg)"-->
<!--            placeholder="请输入内容..."-->
<!--            v-model="acceptance_msg">-->
<!--        </el-input>-->
<!--      </div>-->
<!--    </div>-->

<!--    访客上传权限-->
    <div class="module-item-style" v-if="isAuth.is_upload">
      <div class="module-item-title online-base-title">
        <div>
          访客上传权限
        </div>
        <div class="online-base-switch-btn">
          <el-switch
              v-model="uploadBtn"
              @change="saveChange('uploade_open',uploadBtn)"
              active-color="#68B974">
          </el-switch>
        </div>
      </div>
      <div class="online-base-tips">开启后，访客在线聊天时可以上传图片或者文件</div>
    </div>

	<!--    消息预知-->
    <div class="module-item-style" v-if="isAuth.is_foresee">
      <div class="module-item-title online-base-title">
        <div>
          消息预知
        </div>
        <div class="online-base-switch-btn">
          <el-switch
              v-model="foreseeBtn"
              @change="saveChange('is_notForesee',foreseeBtn)"
              active-color="#68B974">
          </el-switch>
        </div>
      </div>
      <div class="online-base-tips">关闭后，客服将不能看到访客实时输入内容，默认开启</div>
    </div>
	<!--    app端访客上线推送-->
	<div class="module-item-style">
	  <div class="module-item-title online-base-title">
	    <div>
	      访客上线app端推送
	    </div>
	    <div class="online-base-switch-btn">
	      <el-switch
	          v-model="loginNoticeBtn"
	          @change="saveChange('is_open_client_login_notice',loginNoticeBtn)"
	          active-color="#68B974">
	      </el-switch>
	    </div>
	  </div>
	  <div class="online-base-tips">关闭后，客服app端将不会收到访客上线的推送，默认开启</div>
	</div>
	<!--  禁发敏感词  -->
	<div class="module-item-style">
	  <div class="module-item-title online-base-title">
	    <div>
	      禁发敏感词
	    </div>
	    <div class="online-base-switch-btn">
	      <el-switch
	          v-model="sensitiveBtn"
	          @change="saveChange('is_open_sensitive_word',sensitiveBtn)"
	          active-color="#68B974">
	      </el-switch>
	    </div>
	  </div>
	  <div class="online-base-tips">开启后，客服和访客发送的消息将会进行敏感词检测，默认关闭</div>
    <div class="online-base-content" v-if="sensitiveBtn">
      <el-input placeholder="请输入敏感词" :maxlength="20" v-model="sensitiveword" @blur.prevent="addLabel(sensitiveword)" style="width:600px">
        <i slot="prefix" class="el-input__icon el-icon-edit-outline"></i>
      </el-input>
      <div class="online-base-label">
        <el-tag :disable-transitions="true" v-for="(item,index) in wordList" :key="index" closable  @close="handleClose(item)">{{item.sensitiveword}}</el-tag>
      </div>
    </div>
  </div>
	<!--    消息已读显示  -->
	<div class="module-item-style" style="display: none;">
	  <div class="module-item-title online-base-title">
	    <div>
	      客服端，对话是否显示已读未读
	    </div>
	    <div class="online-base-switch-btn">
	      <el-switch
	          v-model="serviceShowReadBtn"
	          @change="saveChange('service_read_permissions',serviceShowReadBtn)"
	          active-color="#68B974">
	      </el-switch>
	    </div>
	  </div>
	  <div class="online-base-tips">开启后，客服能看到消息已读未读显示，默认关闭</div>
	  <div class="online-base-content">
	
	  </div>
	</div>
	<div class="module-item-style" style="display: none;">
	  <div class="module-item-title online-base-title">
	    <div>
	      访客端，对话是否显示已读未读
	    </div>
	    <div class="online-base-switch-btn">
	      <el-switch
	          v-model="visitorShowReadBtn"
	          @change="saveChange('visitor_read_permissions',visitorShowReadBtn)"
	          active-color="#68B974">
	      </el-switch>
	    </div>
	  </div>
	  <div class="online-base-tips">开启后，访客能看到消息已读未读显示，默认关闭</div>
	  <div class="online-base-content">
	
	  </div>
	</div>

    <!--    新消息自动弹出对话框-->
    <div class="module-item-style">
      <div class="module-item-title online-base-title">
        <div>
          客服端，新消息自动弹出对话框
        </div>
        <div class="online-base-switch-btn">
          <el-switch
                  v-model="newCSMessageBtn"
                  @change="saveChange('is_cs_open_popup',newCSMessageBtn)"
                  active-color="#68B974">
          </el-switch>
        </div>
      </div>
      <div class="online-base-tips">开启后，访客发来新消息客服端自动弹出对话窗口，默认关闭</div>
      <div class="online-base-content">

      </div>
    </div>

    <!--    新消息自动弹出对话框-->
    <div class="module-item-style">
      <div class="module-item-title online-base-title">
        <div>
          访客端，新消息自动弹出会话
        </div>
        <div class="online-base-switch-btn">
          <el-switch
                  v-model="newMessageBtn"
                  @change="saveChange('is_open_popup',newMessageBtn)"
                  active-color="#68B974">
          </el-switch>
        </div>
      </div>
      <div class="online-base-tips">开启后，访客端收到新消息自动弹出对话框，默认关闭</div>
      <div class="online-base-content" v-if="newMessageBtn==1">
      		  <div class="module-item-title online-base-title">
      			  <div>
      			    访客端，第一个页面关闭对话框以后，访问其他页面是否自动弹出
      			  </div>
      			  <div class="online-base-switch-btn">
      			    <el-switch
      			            v-model="continuePopupBtn"
      			            @change="saveChange('is_open_continue_popup',continuePopupBtn)"
      			            active-color="#68B974">
      			    </el-switch>
      			  </div>
      		  </div>
      		  <div class="online-base-tips">开启后，访问其他页面自动弹出，默认不弹出</div>
			  <div class="module-item-title online-base-title">设置自动弹出时间（秒）</div>
			  <el-input class="popup-time-input" v-model="popupTime" type="number" max="300" @input="timeLimit()" placeholder="请输入自动弹出时间" @blur="saveChange('open_popup_time',popupTime)"></el-input>
      </div>
    </div>

<!--    自定义标识-->
    <div class="module-item-style">
      <div class="module-item-title online-base-title">
        <div>
          自定义标识
        </div>
        <div class="online-base-switch-btn">
          <el-switch
              @change="saveChange('remove_status',userDefinedBtn)"
              v-model="userDefinedBtn"
              active-color="#68B974">
          </el-switch>
        </div>
      </div>
      <div class="online-base-tips">开启后，管理后台可以自定义设置公司logo</div>
      <div class="online-base-content" v-if="userDefinedBtn">
        <div class="user-defined-tag">
          <div class="big-tag-contaienr">
            <div class="big-tag-image tag-image">
              <img :src="companyLogo.company_icon" width="155" height="35" alt="">
            </div>
            <p class="big-tag-tips"><span>*</span>建议上传120px * 28px大小的图片</p>
            <div class="operation-btn-container">
              <div class="wl-btn-normal" @click="changeNewLogo('company_icon')">换一个新LOGO
              </div>
              <!-- <div class="wl-btn-normal" @click="resetLogo('company_icon','http://weiliao.oss-cn-hangzhou.aliyuncs.com/images/1560493213/6da06185c8644fe59d32af9da463ddd6-logo_mp.png')">还原</div> -->
			  <div class="wl-btn-normal" @click="resetLogo('company_icon','https://weiliao.oss.aliyuncs.com/images/20200421/e7a16b02828147aa996aa9ec680555d5/1587461608650.png')">还原</div>
            </div>
          </div>
          <div class="small-tag-contaienr"v-if="userDefinedBtn">
            <div class="small-tag-image tag-image">
              <img :src="companyLogo.company_small_icon" width="33" height="28" alt="">
            </div>
            <p class="small-tag-tips"><span>*</span>建议上传33px * 28px大小的图片</p>
            <div class="operation-btn-container">
              <div class="wl-btn-normal" @click="changeNewLogo('company_small_icon')">
                换一个新LOGO
              </div>
              <div class="wl-btn-normal" @click="resetLogo('company_small_icon','https://weiliao.oss.aliyuncs.com/images/1560493280/806fb91e34164a4f9b52e1cd7ad19b0d-logo_mp_s.png')">还原</div>
            </div>
          </div>
          <input type="file" ref="changeLogo" @change="uploadLogoImage" style="display: none">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import wangEditor from '@/components/wangEditor'
  export default {
    name: 'setting-online-base',
    components: {
      wangEditor
    },
    data() {
      return {
        accept: 'image/gif, image/jpeg, image/png, image/jpg',
        welecomBtn: false,
        welecomContent:'',
        chatFinishedBtn: false,
        chatFinished:'',
        chatFinishedAuto:'',
        chatFinishedTime:'0',
        uploadBtn: false,
        foreseeBtn:false,
		loginNoticeBtn: false,
		sensitiveBtn:false,
        userDefinedBtn:false,
        newMessageBtn: false,
        newCSMessageBtn: false,
		continuePopupBtn:false,
		serviceShowReadBtn:false,
		visitorShowReadBtn:false,
		popupTime:0,
        companyLogo:{
          company_small_icon:'https://weiliao.oss.aliyuncs.com/images/1560493280/806fb91e34164a4f9b52e1cd7ad19b0d-logo_mp_s.png',
          company_icon:'http://weiliao.oss-cn-hangzhou.aliyuncs.com/images/1560493213/6da06185c8644fe59d32af9da463ddd6-logo_mp.png',
        },

        type:'',
        acceptance_msg: '',
        sensitiveword:'',//敏感词
        wordList:'',//敏感词列表
      }
    },
    created(){
      this.getBaseConfig()
      this.getLabelList()
    },
    mounted() {
    },
    computed:{
      isAuth(){
        return this.$store.state.user.isAuth
      }
    },
    methods: {
	  timeLimit(){
		  if(this.popupTime>300){
			  this.popupTime = 300
		  }
	  },
      // 编辑器组件抛出html的值
      editorBlurEvent(val) {
        // let reg = /&nbsp;/g;
        // const newVal = val.replace(/<(?!img).*?>/g,"") // 去除img以外的标签
        // if (newVal.replace(reg, '').trim().length == 0) {
        //   this.$message({
        //     message: '内容不能为空',
        //     type: 'error'
        //   })
        // } else {

        // }
        this.saveChange('company_greet', val)
      },
      /**
       * 获取可编辑div内容的变化
       * @param event
       * @param name
       */
      getEditDivChange(event, name) {
        let val = event.target.innerHTML
        let valText = event.target.innerText
        console.log(val)
        console.log(valText)
        if (this.welecomContent == val) {
          return false
        }
        if(valText.trim().length == 0){
          if(name == 'company_greet'){
            this.welecomContent = ''
            event.target.innerHTML = ''
          }
          this.saveChange(name, '')
        }else {
          this.saveChange(name, val)
        }
        // let val = event.target.innerHTML
        // if (this.welecomContent == val) {
        //   return false
        // }
        // this.saveChange(name, val)
      },
      addLabel(val){
        // console.log(val)
         this.$http.addSensitiveword({sensitiveword:val}).then( res => {
          if(res.status == 1){
            this.$message({
              message: res.msg,
              type: 'success',
            })
            this.sensitiveword = ''
            this.getLabelList()
          }else {
            this.$message({
              message: res.msg,
              type: 'error',
            })
          }
        })
      },
      getLabelList(){
        this.$http.sensitivewordList().then( res => {
          if(res.status == 1){
            this.wordList = res.data
          }else {
            this.$message({
              message: res.msg,
              type: 'error',
            })
          }
        })
      },
      handleClose(item){
        // console.log(item)
        this.$http.delSensitiveword({sensitivewordId:item.id}).then( res => {
          if(res.status == 1){
            this.$message({
              message: res.msg,
              type: 'success',
            })
            this.getLabelList()
          }else {
            this.$message({
              message: res.msg,
              type: 'error',
            })
          }
        })
      },
      getBaseConfig(){
        this.$http.getBaseConfigAPI().then( res => {
          if(res.status == 1){
            let baseInfo = res.data
			this.popupTime = baseInfo.open_popup_time
            if(baseInfo.company_is_greet == 0){
              this.welecomBtn = false
            }else {
              this.welecomBtn = true
            }
            if (baseInfo.is_open_popup == 0) {
              this.newMessageBtn = false
            } else {
              this.newMessageBtn = true
            }
			if (baseInfo.is_open_continue_popup == 0) {
			  this.continuePopupBtn = false
			} else {
			  this.continuePopupBtn = true
			}
            if (baseInfo.is_cs_open_popup == 0) {
              this.newCSMessageBtn = false
            } else {
              this.newCSMessageBtn = true
            }
            if(baseInfo.is_notForesee == 1){
              this.foreseeBtn = false
            }else {
              this.foreseeBtn = true
            }
			if(baseInfo.is_open_client_login_notice == 1){
			  this.loginNoticeBtn = true
			}else {
			  this.loginNoticeBtn = false
			}
			if(baseInfo.is_open_sensitive_word == 1){
			  this.sensitiveBtn = true
			}else {
			  this.sensitiveBtn = false
			}
			if(baseInfo.service_read_permissions == 1){
			  this.serviceShowReadBtn = true
			}else {
			  this.serviceShowReadBtn = false
			}
			if(baseInfo.visitor_read_permissions == 1){
			  this.visitorShowReadBtn = true
			}else {
			  this.visitorShowReadBtn = false
			}
            if(baseInfo.peroration_open == 0){
              this.chatFinishedBtn = false
            }else {
              this.chatFinishedBtn = true
            }
            if(baseInfo.remove_status == 0){
              this.userDefinedBtn = false
            }else {
              this.userDefinedBtn = true
            }
            if(baseInfo.uploade_open == 0){
              this.uploadBtn = false
            }else {
              this.uploadBtn = true
            }
            this.welecomContent = baseInfo.company_greet
            this.chatFinished = baseInfo.peroration_close_c
            this.chatFinishedAuto = baseInfo.peroration_close_s
            this.chatFinishedTime = baseInfo.peroration_close_time
            this.companyLogo.company_small_icon = this.checkImage(baseInfo.company_small_icon) ? baseInfo.company_small_icon : this.companyLogo.company_small_icon
            this.companyLogo.company_icon = this.checkImage(baseInfo.company_icon) ? baseInfo.company_icon : this.companyLogo.company_icon

            this.$store.dispatch('user/changeCompanyLogo',this.companyLogo)
            setTimeout(() => {
              if(this.$refs.wangEditors){
                this.$refs.wangEditors.editor.txt.html(baseInfo.company_greet)
              }

            }, 1000)
          }
        })

        // this.$http.getacceptanceMsgAPI().then(res => {
        //   if(res.status == 1){
        //         this.acceptance_msg = res.data.configValue
        //   }
        // })
      },
      checkImage(img){
        let reg = new RegExp(/(http|https):\/\/([\w.]+\/?)\S*/,'g')
        return reg.test(img)
      },
      /**
       * 修改logo
       */
      changeNewLogo(type){
        this.type = type
        this.$refs.changeLogo.click()
      },
      /**
       * 上传logo
       * */
      uploadLogoImage(e){
        let img = e.target.files[0]
        let type = img.type
        let size = img.size
        if (this.accept.indexOf(type) == -1) {
          this.$message({
            showClose: true,
            message: '图片格式不正确，请选择我们支持的图片格式 .gif, .jpeg, .png, .jpg',
            type: 'error',
            duration: 3 * 1000
          })
          return false
        }
        if (size > 5242880) {
          this.$message({
            showClose: true,
            message: '请选择5M以内的图片！',
            type: 'error',
            duration: 3 * 1000
          })
          return false
        }
        let formdata = new FormData()
        formdata.set('file',img)
        this.$http.uploadImageAPI(formdata).then( res => {
            if(res.status == 1){
              if(this.type == 'company_small_icon'){
                this.companyLogo.company_small_icon = res.data
              }else if('company_icon'){
                this.companyLogo.company_icon = res.data
              }
              this.saveChange(this.type,res.data)
            }


        })
      },
      /**
       * 还原logo
       */
      resetLogo(name,value){
        this.$confirm('是否要还原到系统默认标识?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.saveChange(name,value)
        })
      },
      /**
       * 保存修改
       */
      saveChange(name,value){
        let postValue ;
        if(name == 'peroration_close_time' && value == ''){
          this.$message({
            message: '保存失败',
            type: 'error',
          })
          return
        }
        if(name == 'is_notForesee'){
          if(value == 'true' || value == true){
            postValue = 0
          }else if (value == 'false' || value == false) {
            postValue = 1
          }
        } else {
		  if((value == 'true' || value == true)){
		    postValue = 1
		  }else if (value == 'false' || value == false) {
		    postValue = 0
		  }else {
		    postValue = value
		  }
        }

        this.$http.saveConfigAPI({
          name,
          value:postValue
        }).then( res => {
          if (this.$refs.changeLogo) {
            this.$refs.changeLogo.value = ''
          }
          if(res.status == 1){
            this.$message({
              message: res.msg,
              type: 'success',
            })
            this.getBaseConfig()
          }else {
            this.$message({
              message: res.msg,
              type: 'error',
            })
          }
        })
      },
      saveTips(name, value){
          this.$http.setAcceptanceMsgAPI({
            value: value
          }).then(res => {
            if(res.status == 1){
              this.$message({
                message: res.msg,
                type: 'success',
              })
              this.getBaseConfig()
            }else {
              this.$message({
                message: res.msg,
                type: 'error',
              })
            }
          })
      },
    }
  }
</script>

<style lang="scss">
  .setting-online-base {
    .input-width{
      width: 600px;
    }
    .can-edit-div-box {
      width: 600px;
      height: 100px;
      border-radius: $mainBorderRadius;
      border: solid 1px #e4e7ed;
      padding: 8px;

      .can-edit-div {
        width: 100%;
        height: 100%;
        outline: none;
        overflow-y: scroll;

        &:empty:before {
          content: attr(data-placeholder);
          color: #bbb;
        }

        &:focus:before {
          content: none;
        }
      }
    }
    .online-base-tips {
      color: #999;
      font-size: 12px;
      padding: 12px 0 15px 0;
    }
    .online-base-title{
      display: flex;
      .online-base-switch-btn{
        margin-left: auto;
      }
    }
    .online-base-content{
		.popup-time-input{
			width: 200px;
			margin-top: 15px;
		}
      .input-textarea{
        width: 600px;
      }
      .user-defined-tag{
        display: flex;
        color: #999;
        .big-tag-contaienr{
          text-align: center;
          margin-right: 59px;
          .big-tag-image{
            width: 334px;
            height: 79px;
            background-color: #F4F4F4;
            img{
              max-width: 240px;
              max-height: 56px;
            }
          }
          .big-tag-tips{
            padding-top: 15px;
            font-size: 12px;
            span{
              color: #FF743E;
              padding-right: 3px;
            }
          }
        }
        .small-tag-contaienr{
          text-align: center;
          .small-tag-image{
            width: 84px;
            margin: 0 auto;
            height: 79px;
            background-color: #F4F4F4;
            img{
              max-width: 66px;
              max-height: 56px;
            }
          }
          .small-tag-tips{
            padding-top: 15px;
            font-size: 12px;
            span{
              color: #FF743E;
              padding-right: 3px;
            }
          }
        }
        .tag-image{
          position: relative;
          img{
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%,-50%);
          }
        }
      }
      .operation-btn-container{
        display: flex;
        justify-content: center;
        padding-top: 39px;
        & > div + div{
          margin-left: 28px;
        }
      }

      .chat-finish{
        .chat-finish{
          color: #333;
          font-size: 12px;
          padding-bottom: 12px;
        }
        .chat-finish-time-set{
          color: #666;
          padding-top: 40px;
          font-size: 12px;
        }
        .chat-finish-num{
          width:60px;
          height:26px;
          background:rgba(255,255,255,1);
          border:1px solid rgba(238,238,238,1);
          border-radius:2px;
          outline: none;
          padding: 5px;
          text-align: center;
        }
      }
      .chat-finish + .chat-finish{
        margin-top: 40px;
      }
    }
    .online-base-label{
      margin: 10px 0;
      .el-tag{
        margin: 5px 10px 5px 0;
      }
    }
  }
</style>
